<template>
  <section>
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      class="importDialog"
      :title="title"
      :visible.sync="show"
      width="500px"
    >
      <!-- 第1和第2所有上传统一，其他描述slot写入描述 -->
      <div v-show="state == 0" class="descClass">
        <span>请按以下步骤导入：</span>
        <br />
        <span>
          1、<span class="downLoadTmp" @click="downloadDemo">下载模板</span>
        </span>
        <br />
        <span>
          2、根据模板填写信息，上传填写后的Excel文件
        </span>
        <br />
        <slot name="desc"></slot>
      </div>
      <div v-show="state == 0">
        <el-upload
          name="file"
          style="width: 100%;"
          class="upload-demo"
          drag
          action=""
          :http-request="uploadFile"
          :show-file-list="false"
          :accept="uploaAccept"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            可直接拖拽文件到这里上传或
            <em>浏览文件</em>
          </div>
        </el-upload>
      </div>
      <div v-show="state == 1" style="padding: 25px 0">
        <el-row :gutter="20">
          <el-col :span="12" style="line-height: 50px;text-align: right;">
            文件正在上传
            <div class="el-loading-spinner" style="left: 40px;">
              <svg viewBox="25 25 50 50" class="circular">
                <circle
                  cx="50"
                  cy="50"
                  r="20"
                  fill="none"
                  class="path"
                ></circle>
              </svg>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-show="state == 2" style="padding: 25px 0">
        <el-row :gutter="20">
          <el-col :span="15" style="line-height: 50px;text-align: right;"
            >文件上传完成，正在导入</el-col
          >
          <el-col :span="7">
            <el-progress
              :width="50"
              :stroke-width="4"
              type="circle"
              :percentage="precent"
            ></el-progress>
          </el-col>
        </el-row>
      </div>
      <div v-show="state == 3">
        <div class="importResult">
          <span>共识别到的数据：{{ importInfo.total }}条</span>
          <br />
          <span>导入成功数量：{{ importInfo.successCount }}条</span>
          <!-- <br v-if="Number(importInfo.failCount) > 0" /> -->
          <span
            v-if="Number(importInfo.failCount) > 0"
            @click="downloadSuccessFile"
            class="downLoadTmp mgLeft10"
          >
            下载成功数据
          </span>
          <br v-if="Number(importInfo.failCount) > 0" />
          <span v-if="Number(importInfo.failCount) > 0">
            导入失败数量：{{ importInfo.failCount }}条
          </span>
          <!-- <br v-if="Number(importInfo.failCount) > 0" /> -->
          <span
            v-if="Number(importInfo.failCount) > 0"
            @click="downloadFailFile"
            class="downLoadErr mgLeft10"
          >
            下载失败数据
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-show="state == 0"
          @click="cancelDialog"
          size="small"
          style="font-size: 14px;"
        >
          取 消
        </el-button>
        <el-button
          v-show="state == 3"
          type="primary"
          @click="makeSure"
          size="small"
          style="font-size: 14px;"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
export default {
  name: "",
  props: {
    title: {
      type: String,
      default: "文件上传"
    },
    show: {
      type: Boolean,
      default: false
    },
    templateUrl: {
      type: String,
      default: ""
    },
    uploadUrl: {
      type: String,
      default: ""
    },
    importUrl: {
      type: String,
      default: ""
    },
    progressUrl: {
      type: String,
      default: ""
    },
    otherParams: {
      type: Object,
      default: () => {
        return {};
      }
    },
    downloadDemoName: {
      type: String,
      default: "人员导入模板"
    },
    downloadFailFileName: {
      type: String,
      default: "导入失败成员"
    },
    downloadSuccessFileName: {
      type: String,
      default: "导入成功成员"
    },
    uploaAccept: {
      type: String,
      default:
        "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  },
  data() {
    return {
      importInfo: {
        total: 0,
        successCount: 0,
        failCount: 0,
        successFile: "",
        failFile: ""
      },
      state: 0, // 0 - 未上传 1 - 上传中 2 -导入中 3-导入完成
      precent: 0,
      taskId: "",
      intervalClass: null
    };
  },
  methods: {
    uploadFile(req) {
      // this.state = 2;
      const data = new FormData();
      data.append("file", req.file);
      this.$common
        .http({
          url: this.uploadUrl,
          file: data,
          noLoading: true
        })
        .then(res => {
          this.$common
            .http({
              url: this.importUrl,
              data: { file: res.data.data },
              retuenReject: true
            })
            .then(res1 => {
              if (!(res1.data.data && res1.data.data.task_id)) {
                this.state = 0;
                return;
              }
              this.state = 2;
              this.taskId = res1.data.data.task_id;
              this.intervalClass = setInterval(() => {
                this.$common
                  .http({
                    method: "post",
                    url: this.progressUrl,
                    data: {
                      task_id: this.taskId
                    },
                    noLoading: true
                  })
                  .then(res2 => {
                    // 显示进度
                    this.percent = res2.data.data.percent;
                    if (res2.data.data.finish == 1) {
                      this.state = 3;
                      this.importInfo = {
                        total: res2.data.data.result.total,
                        successCount: res2.data.data.result.success_total || 0,
                        failCount: res2.data.data.result.fail_total || 0,
                        successFile: res2.data.data.result.success_file || "",
                        failFile: res2.data.data.result.fail_file || ""
                      };
                      window.clearInterval(this.intervalClass);
                      // 显示结果
                    }
                  });
              }, 1000);
            });
        });
    },
    makeSure() {
      this.$emit("updateVisible", false);
      this.$emit("callback");
      setTimeout(() => {
        this.state = 0;
      }, 2000);
    },
    downloadDemo() {
      this.$common.httpLoadFile({
        url: this.templateUrl,
        downloadName: this.downloadDemoName
      });
    },
    cancelDialog() {
      this.$emit("updateVisible", false);
    },
    downloadFailFile() {
      this.$common.httpLoadFile({
        url: this.importInfo.failFile,
        downloadName: this.downloadFailFileName
      });
    },
    downloadSuccessFile() {
      this.$common.httpLoadFile({
        url: this.importInfo.successFile,
        downloadName: this.downloadSuccessFileName
      });
    }
  },
  components: {},
  computed: {},
  created() {},
  mounted() {},
  watch: {}
};
</script>
<style lang="less">
.importDialog {
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-upload,
  .el-upload-dragger {
    width: 100%;
  }

  .descClass {
    line-height: 30px;
    margin-bottom: 15px;
  }

  .downLoadTmp {
    text-decoration: underline;
    color: #409eff;
    cursor: pointer;
  }
  .mgLeft10 {
    margin-left: 10px;
  }
  .downLoadErr {
    text-decoration: underline;
    color: #fb687d;
    cursor: pointer;
  }
  .mgLeft10 {
    margin-left: 10px;
  }
  .importResult {
    line-height: 30px;
    > span {
      display: inline-block;
    }
  }
}
</style>
